require('../css/chat.css')
import moment from 'moment-timezone';

import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import $ from 'jquery'
import Error from './Error.jsx'
import Interval from '../mixins/interval'

//depreciated 03/28/2020 by bcd
//const CHAT_API_URI = 'https://player.streamspot.com/chat-process.php'
let CHAT_API_URI = 'https://chat.streamspot.com/chat'
if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
  console.log('Testing URL detected; using stage chat');
  CHAT_API_URI = 'https://testing-chat.streamspot.com/chat'
}


/**
 * Generate a random color or return saved color stored
 * in local storage
 * @return {color} A hex color
 */
function getRandomColorOrSavedColor() {
  var localStorageColor = localStorage.getItem('chat-color')
  if(!_.isEmpty(localStorageColor)) return localStorageColor
  var letters = '0123456789ABCDEF'.split('')
  var color = '#'
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  localStorage.setItem('chat-color', color)
  return color
}

function getRandomNameOrSavedName(){
  var localStorageName = localStorage.getItem('chat-name')
  if(!_.isEmpty(localStorageName)) return localStorageName
  var name = 'Guest' + Math.floor((Math.random() * 100) + 1).toString()
  saveName(name)
  return name
}

function saveName(name){
  localStorage.setItem('chat-name', name)
}

function generateMessageString(color, name, message){
  const tzString = moment.tz.guess();
  const tzAbbr = moment.tz(tzString).format("z");
  const currentTime = moment().format('MM/DD/YY h:mma')+' '+tzAbbr
  return '<span class=\'label\'>'+currentTime+'</span><span style=\'background-color: '+color+'; text-shadow: 0 0 2px #000;\'>'+name +'</span>' + message
}



var ChatBox = React.createClass({
  mixins: [Interval],
  getInitialState: function() {
    return {
      messages: [],
      errorMessage: null,
      chatState: null,
      broadcaster: null,
      name: getRandomNameOrSavedName(),
      color: getRandomColorOrSavedColor(),
      view: 'chat'
    }
  },
  componentDidMount : function() {
    this.setState({
      broadcaster: this.props.broadcaster || window.Player.broadcaster.ssId
    })
    $.ajax({
      type: 'POST',
      url: CHAT_API_URI,
      data: {
        'function': 'getState',
        'church': this.state.broadcaster
      },
      dataType: 'json',
      success: function(data) {
        this.setState({chatState: data.state})
        $.ajax({
          type: 'POST',
          url: CHAT_API_URI,
          data: {
            'function': 'update',
            'state': this.state.chatState,
            'church': this.state.broadcaster
          },
          dataType: 'json',
          success: function(data) {
            if (data.text) {
              if (this.isMounted()){
                data.text = this.timezoneAdjust(data.text)
                this.setState({
                  messages: data.text.reverse(),
                  chatState: data.state
                })
                this.setInterval(this.update, 5000)
              }
            }
          }.bind(this)
        })
      }.bind(this)
    })
  },
  timezoneAdjust:function(text){
    //return text
    const format = 'MM/DD/YY h:mma'
    //const default_zone  = window.Player.broadcaster.timezone //does not work with chat widget
    const default_zone  = "America/New_York"
    // Local timezone
    const tzString = moment.tz.guess() // 'America/Los_Angeles'
    const tzAbbr = moment.tz(tzString).format("z")

    for(let i=0; i<text.length; i++) {
      let nodes = $($.parseHTML(text[i]))
      if (typeof nodes!=='undefined' && nodes.length > 0 && typeof nodes[0].innerText!=='undefined') {
        let datetime = nodes[0].innerText.trim()
        let dateObj = moment.tz(datetime, format, default_zone)
        //console.log("before:"+dateObj.format(format))
        const converted_time = dateObj.tz(tzString).format(format) + " " + tzAbbr
        //console.log("after:"+converted_time)
        nodes[0].innerText = converted_time
        text[i] = text[i].replace(datetime, converted_time)
      }
      else {
        delete text[i]
      }
    }
    return text
  },
  update: function(){
    $.ajax({
      type: 'POST',
      url: CHAT_API_URI,
      data: {
        'function': 'update',
        'state': this.state.chatState,
        'church': this.state.broadcaster
      },
      dataType: 'json',
      success: function(data) {
        if (data.text) {
          data.text = this.timezoneAdjust(data.text)
          this.setState({
            messages: data.text.reverse(),
            chatState: data.state
          })
        }
      }.bind(this)
    })
  },
  goToSettings: function(){
    this.setState({
      view: 'settings'
    })
  },
  updateName: function(name){
    this.setState({
      name: name
    })
    saveName(name)
  },
  goToChat: function(){
    this.setState({
      view: 'chat'
    })
  },
  submitMessage: function(message) {
    var messages = this.state.messages
    if(_.isEmpty(message)){
      this.setState({errorMessage: 'Sorry, your message looks blank'})
      return
    }
    $.ajax({
      type: 'POST',
      url: CHAT_API_URI,
      data: {
        'function': 'send',
        'message': message,
        'nickname': this.state.name,
        'color': this.state.color,
        'church': this.state.broadcaster
      },
      dataType: 'json',
      success: function() {
        var formattedMessage = generateMessageString(this.state.color, this.state.name, message)
        messages.push(formattedMessage)
        this.setState({messages: messages, errorMessage: null})
      }.bind(this)
    })
  },
  handlePopout: function(){
    let baseUrl = 'https://venue.streamspot.com/';
    if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
      baseUrl = 'https://testing-venue.streamspot.com/';
    }
    window.open(baseUrl+'chat/'+this.state.broadcaster,'', 'width=400, height=430')
  },
  render: function() {
    if(this.state.view === 'settings'){
      return (
        <Settings name={this.state.name} goBack={this.goToChat} updateName={this.updateName} />
      )
    }else{
      if(this.props.popout || (window.Player && window.Player.mobile)){
        return (
          <div id="chatbox">
            <div id="chatbox-header">
              <span>Your name: <span style={{'backgroundColor': this.state.color}} className="name-label">{this.state.name}</span></span>
            </div>
            <Error message={this.state.errorMessage}/>
            <MessageList messages={this.state.messages}/>
            <ChatForm goToSettings={this.goToSettings}  onSubmit={this.submitMessage}/>
          </div>
        )
      }else{
        return (
          <div id="chatbox">
            <div id="chatbox-header">
              <span>Your name: <span style={{'backgroundColor': this.state.color}} className="name-label">{this.state.name}</span></span>
              <button style={{float: 'right'}}  className="btn btn-streamspot" onClick={this.handlePopout} type="submit"><i className="fa fa-external-link"></i></button>
            </div>
            <Error message={this.state.errorMessage}/>
            <MessageList messages={this.state.messages}/>
            <ChatForm goToSettings={this.goToSettings} onSubmit={this.submitMessage}/>
          </div>
        )
      }
    }
  }
})

var Settings = React.createClass({
  componentDidMount: function(){
    this.refs.name.value = this.props.name
  },
  onSubmit: function(e) {
    e.preventDefault()
    var name = this.refs.name.value
    this.props.updateName(name)
    this.props.goBack()
    return false
  },
  render: function() {
    return (
      <div id="chat-settings">
        <h3><i className="fa fa-cog"></i> Settings</h3>
        <form name="updateChat" id="updateChat" style={{
          'marginBottom': '0px !important'
        }}>
          <p>Change Name: </p>
          <div className="input-group">
            <input type="text" className="form-control" ref='name' maxLength="18"/>
            <span className="input-group-btn">
              <button className="btn btn-streamspot" onClick={this.onSubmit} type="submit">Update</button>
            </span>
          </div>
        </form>
        <button style={{
          'marginTop': '10px'
        }} className="btn btn-streamspot" onClick={this.props.goBack}>Go Back</button>
      </div>
    )
  }
})

var ChatForm = React.createClass({
  onSubmit: function(e) {
    e.preventDefault()
    var message = this.refs.message.value
    this.props.onSubmit(message)
    this.refs.message.value = ''
    return false
  },
  render: function() {
    return (
      <div id="chat-form">
        <form name="updateChat" id="updateChat" style={{'marginBottom': '0px !important'}}>
          <div className="input-group">
            <input type="text" className="form-control" ref='message' maxLength="140" placeholder="Say something..."/>
            <span className="input-group-btn">
              <button className="btn btn-streamspot" onClick={this.onSubmit} type="submit">Submit</button>
              <button onClick={this.props.goToSettings} className="btn btn-streamspot" type="button"><i className="fa fa-cog"></i></button>
            </span>
          </div>
        </form>
      </div>
    )
  }
})

var scrollToBottom = function(){
  var topPos = document.getElementById('chatbox-messages').lastChild.offsetTop
  document.getElementById('chatbox-messages').scrollTop = topPos-10
}

var MessageList = React.createClass({
  propTypes: {
    messages: React.PropTypes.array.isRequired
  },
  componentDidUpdate: function(){
    if(!this.messageLength) this.messageLength = 0
    if(this.props.messages.length > this.messageLength){
      scrollToBottom()
      this.messageLength = this.props.messages.length
    }
  },
  render: function() {
    var messages = []
    this.props.messages.forEach(function(message, index) {
      if(index === (this.props.messages.length - 1)) return messages.push(<Message first={true} key={index} message={message}/>)
      messages.push(<Message key={index} message={message}/>)
    }.bind(this))
    return (
      <div id="chatbox-messages">
        {messages}
      </div>
    )
  }
})

var Message = React.createClass({
  propTypes: {
    message: React.PropTypes.string.isRequired
  },
  render: function() {
    var message = this.props.message
    function createMarkup() {
      return {__html: message}
    }
    if(this.props.first){
      return(
        <div id="chatbox-first-message">
          <p dangerouslySetInnerHTML={createMarkup()}></p>
        </div>
      )
    }else{
      return (
        <div>
          <p dangerouslySetInnerHTML={createMarkup()}></p>
        </div>
      )
    }
  }
})

module.exports = ChatBox

window.ChatBox = {
  el: null,
  options: {},
  render: function(el, options){
    _.extend(this.options, options)
    this.el = el
    ReactDOM.render(React.createElement(ChatBox, options), document.getElementById(this.el))
  },
  unmount: function(){
    if(this.el) ReactDOM.unmountComponentAtNode(document.getElementById(this.el))
    this.el = null
  }
}



// WEBPACK FOOTER //
// ./src/components/Chat.jsx